import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeBuyingDashboardHome, routeBuyingDashboardRoot } from './buyingDashboardRoutes'
import { routePurchaseOrdersRoot } from './purchaseOrderRoutes'
import { routeRequestForQuotationsRoot } from './requestForQuotationRoutes'
import { routeSupplierQuotationsRoot } from './supplierQuotationRoutes'

const routeBuyingHome: RouteRecordRaw = {
  name: 'buying-home',
  path: '',
  redirect: routeBuyingDashboardHome,
}

const routeBuyingRoot: RouteRecordRaw = {
  children: [
    routeBuyingHome,
    routeBuyingDashboardRoot,
    routeRequestForQuotationsRoot,
    routeSupplierQuotationsRoot,
    routePurchaseOrdersRoot,
  ],
  path: 'buying',
}

const redirectBuying: RedirectRouteRelative = {
  name: routeBuyingHome.name,
}

export { redirectBuying, routeBuyingRoot }
